import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Utensils, Clock, MapPin, Star } from 'lucide-react';
export function HomePage() {
  return <div className="flex flex-col" data-id="element-228">
      {/* Hero Section */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden" data-id="element-229">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0" data-id="element-230">
          <img src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="BBQ Background" className="w-full h-full object-cover opacity-40" data-id="element-231" />
          <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/80 to-transparent" data-id="element-232" />
        </div>

        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto" data-id="element-233">
          <div className="inline-block bg-primary px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest mb-6 animate-fade-in" data-id="element-234">
            Approved by Beans the BBQ Dog
          </div>
          <h1 className="text-5xl md:text-7xl font-retro text-white mb-6 leading-tight drop-shadow-xl" data-id="element-235">
            HOME OF THE <span className="text-primary" data-id="element-236">BBQ TRAIN</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto font-light" data-id="element-237">
            Your neighborhood food mart serving award-winning BBQ, cold drinks,
            and daily essentials.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-238">
            <Link to="/menu" data-id="element-239">
              <Button size="lg" className="w-full sm:w-auto" data-id="element-240">
                View Menu
              </Button>
            </Link>
            <Link to="/catering" data-id="element-241">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-242">
                Order Catering
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-20 px-4 max-w-7xl mx-auto w-full" data-id="element-243">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-244">
          <Card className="text-center p-6 hover:border-primary transition-colors group" data-id="element-245">
            <div className="w-16 h-16 bg-dark-lighter rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 transition-colors" data-id="element-246">
              <Utensils className="w-8 h-8 text-primary" data-id="element-247" />
            </div>
            <h3 className="text-xl font-retro mb-3" data-id="element-248">BBQ Thursdays</h3>
            <p className="text-gray-400" data-id="element-249">
              Don't miss our famous BBQ Thursdays! Freshly smoked ribs, pulled
              pork, and brisket served all day until sold out.
            </p>
          </Card>

          <Card className="text-center p-6 hover:border-primary transition-colors group" data-id="element-250">
            <div className="w-16 h-16 bg-dark-lighter rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 transition-colors" data-id="element-251">
              <Clock className="w-8 h-8 text-primary" data-id="element-252" />
            </div>
            <h3 className="text-xl font-retro mb-3" data-id="element-253">Open Late</h3>
            <p className="text-gray-400" data-id="element-254">
              We're here when you need us. Open Mon-Sat until 10pm and Sundays
              until 9pm for all your late-night cravings.
            </p>
          </Card>

          <Card className="text-center p-6 hover:border-primary transition-colors group" data-id="element-255">
            <div className="w-16 h-16 bg-dark-lighter rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 transition-colors" data-id="element-256">
              <Star className="w-8 h-8 text-primary" data-id="element-257" />
            </div>
            <h3 className="text-xl font-retro mb-3" data-id="element-258">One Stop Shop</h3>
            <p className="text-gray-400" data-id="element-259">
              From lottery tickets and propane to fresh coffee and groceries,
              we're your convenient neighborhood stop.
            </p>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary py-16 px-4 text-center" data-id="element-260">
        <div className="max-w-4xl mx-auto" data-id="element-261">
          <h2 className="text-3xl md:text-5xl font-retro text-white mb-6" data-id="element-262">
            Planning a Party?
          </h2>
          <p className="text-xl text-white/90 mb-8" data-id="element-263">
            Let the BBQ Train cater your next event! We handle everything from
            backyard BBQs to corporate lunches.
          </p>
          <Link to="/catering" data-id="element-264">
            <Button variant="secondary" size="lg" className="bg-white text-primary hover:bg-gray-100" data-id="element-265">
              Get a Quote
            </Button>
          </Link>
        </div>
      </section>
    </div>;
}